// FNP-1016: reads for the ApplicationInfrastructure inventory.

// ⚠️ `stages` is selected in FULL. A partial stage selection would render an
// inventory that LOOKS complete while missing the field teardown actually needs
// (`infraStackName`), and the read-amend-write cycle behind
// `updateApplicationInfrastructure` — which REPLACES the array wholesale —
// would then write the truncated version back and destroy the real data.
const APPLICATION_INFRASTRUCTURE_FIELDS = `
    id
    applicationId
    sourceRepositoryName
    infraRepositoryName
    sourcePipelineId
    infraPipelineId
    deploymentAccountGroupId
    stages {
        stage
        accountId
        region
        infraStackName
        deploymentBucketName
        domain
        hostedZoneId
        certificateArn
    }
    infrastructureStatus
    infraRepositoryConfirmation
    sourceRepositoryConfirmation
    infraPipelineConfirmation
    sourcePipelineConfirmation
    provisioningExecutionId
    origin
    protected
    created
    createdByUsername
    updated
    updatedByUsername
`;

// Newest first. One application may have SEVERAL records over its lifetime
// (append-only per provisioning act); at most one is non-terminal at a time.
export const listApplicationInfrastructure = `
    query listApplicationInfrastructure($applicationId: ID!, $limit: Int, $nextToken: String) {
        listApplicationInfrastructure(applicationId: $applicationId, limit: $limit, nextToken: $nextToken) {
            items {
                ${APPLICATION_INFRASTRUCTURE_FIELDS}
            }
            nextToken
        }
    }
`;

export const getApplicationInfrastructure = `
    query getApplicationInfrastructure($id: ID!) {
        getApplicationInfrastructure(id: $id) {
            ${APPLICATION_INFRASTRUCTURE_FIELDS}
        }
    }
`;

export {APPLICATION_INFRASTRUCTURE_FIELDS};
